import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 md:py-28 bg-white relative overflow-hidden" data-id="element-47">
      <div className="container mx-auto px-4 relative z-10" data-id="element-48">
        <div className="max-w-4xl mx-auto text-center" data-id="element-49">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-darkGreen to-gray-900 rounded-[3rem] p-10 md:p-16 shadow-2xl relative overflow-hidden" data-id="element-50">
            {/* Decorative background elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-vibrantGreen/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-51"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-vibrantGreen/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-52"></div>

            <h2 className="text-3xl md:text-5xl font-black text-white mb-6 font-montserrat leading-tight relative z-10" data-id="element-53">
              Empieza Hoy a Comer Rico y{' '}
              <span className="text-vibrantGreen" data-id="element-54">Verte Mejor</span>
            </h2>

            <p className="text-gray-300 text-lg md:text-xl mb-10 max-w-2xl mx-auto relative z-10" data-id="element-55">
              No dejes pasar esta oferta única. Únete a miles de personas que ya
              están logrando sus objetivos sin dietas aburridas.
            </p>

            <div className="relative z-10 max-w-md mx-auto" data-id="element-56">
              <a href="https://recetasexpress.store" target="_blank" rel="noopener noreferrer" className="group relative flex items-center justify-center w-full bg-vibrantGreen hover:bg-[#40a075] text-darkGreen font-black text-xl py-6 px-8 rounded-2xl shadow-[0_0_30px_rgba(82,183,136,0.3)] hover:shadow-[0_0_40px_rgba(82,183,136,0.5)] transition-all duration-300 transform hover:-translate-y-1 overflow-hidden" data-id="element-57">
                <div className="absolute inset-0 bg-white/20 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-out" data-id="element-58"></div>
                <span className="relative z-10 flex items-center gap-2" data-id="element-59">
                  QUIERO MIS RECETAS FITNESS
                  <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-60" />
                </span>
              </a>
              <p className="text-white/60 text-sm mt-4" data-id="element-61">
                Acceso inmediato • Pago seguro
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}